import $ from "cash-dom";

/**
 * Global variables and functions
 */
const globals = {
    /**
     * Debug Mode
     */
    debug: true,
    /**
     * Scrolling
     */
    isScrolling: false,
    /**
     * Screen Orientation
     */
    screenOrientation: window.innerWidth > window.innerHeight ? "landscape" : "portrait",
    /**
     * Visibility Threshold
     */
    visibilityThreshold: {
        portrait: 1,
        landscape: 0.9,
    },
    /**
     * Strings
     */
    strings: jdmn_l10n,
    /**
     * Pause Scroll
     */
    pauseScroll: function (_n = 1000) {
        this.isScrolling = true;
        setTimeout(function () {
            this.isScrolling = false;
        }, _n);
    },
    /**
     * Resize Obverser
     */
    documentResizeObserver: function () {
        function throttle(f, delay) {
            let timer = 0;
            return function (...args) {
                clearTimeout(timer);
                timer = setTimeout(() => f.apply(this, args), delay);
            };
        }

        new ResizeObserver(
            throttle((entries) => {
                for (var entry of entries) {
                    var width = Math.round(entry.contentRect.width),
                        height = Math.round(entry.contentRect.height);
                    console.log(`document resized to ${width} x ${height}px`);
                }
            }, 100)
        ).observe(document.documentElement);
    },
    /**
     * Populate Lightbox
     */
    populateLightbox: function (_html) {
        $(".lightbox").addClass("is-visible").removeClass("pointer-none").find(".lightbox-inner").html(_html);
    },
    /**
     * Replace Text
     */
    replaceText(_this, _caption) {
        var caption = _caption;
        var text = $(_this).find(".description").html();

        caption.html(text);
    },
    /**
     * Refocus Image
     */
    refocusImage(_this) {
        var values = {
            x: $(_this).attr("data-x"),
            y: $(_this).attr("data-y"),
            zoom: $(_this).attr("data-zoom"),
        };
        var image = _this.parentElement.previousElementSibling.querySelector(".panning-image-element .source-image");

        image.style.transformOrigin = `${values.x} ${values.y}`;
        image.style.transform = `scale(${values.zoom})`;
    },
    resetImage(_this) {
        var image = _this.parentElement.previousElementSibling.querySelector(".panning-image-element .source-image");
        image.style.transformOrigin = `50% 50%`;
        image.style.transform = `scale(1)`;
    },
};

export default globals;
